const root = document.documentElement;
const REDUCED_MOTION_QUERY = '(prefers-reduced-motion: reduce)';
const TARGET_SELECTOR = '[data-route-entry-target]';
const REVEAL_BLUR = 2;
const REVEAL_DURATION = 400;
const REVEAL_EASING = 'ease-in-out';

const dismissArrivalSkeleton = () => {
  window.SigmaPageLoadingArrival?.dismiss({ duration: 0 });
};

const complete = () => {
  root.dataset.routeEntryState = 'complete';
  document.querySelectorAll('.is-route-entry-active').forEach((element) => {
    element.classList.remove('is-route-entry-active');
  });
};

const intersectsInitialViewport = (element) => {
  const bounds = element.getBoundingClientRect();
  const style = window.getComputedStyle(element);

  return (
    style.display !== 'none' &&
    style.visibility !== 'hidden' &&
    bounds.width > 0 &&
    bounds.height > 0 &&
    bounds.bottom > 0 &&
    bounds.top < window.innerHeight
  );
};

const play = () => {
  if (root.dataset.routeEntryState !== 'pending') {
    dismissArrivalSkeleton();
    return;
  }

  if (
    window.matchMedia(REDUCED_MOTION_QUERY).matches ||
    Boolean(window.Shopify?.designMode && window.self !== window.top) ||
    typeof Element.prototype.animate !== 'function'
  ) {
    window.SigmaPageLoadingArrival?.dismiss({ duration: 0 });
    complete();
    return;
  }

  const candidates = [...document.querySelectorAll(TARGET_SELECTOR)];
  const visibleTargets = candidates.filter(intersectsInitialViewport);

  if (visibleTargets.length === 0) {
    dismissArrivalSkeleton();
    complete();
    return;
  }

  dismissArrivalSkeleton();

  const animations = visibleTargets.map((element) => {
    element.classList.add('is-route-entry-active');

    return element.animate(
      [
        { opacity: 0, filter: `blur(${REVEAL_BLUR}px)` },
        { opacity: 1, filter: 'blur(0)' },
      ],
      {
        duration: element.hasAttribute('data-editorial-entry-delay') ? 320 : REVEAL_DURATION,
        delay: Math.min(80, Math.max(0, Number(element.dataset.editorialEntryDelay) || 0)),
        easing: REVEAL_EASING,
        fill: 'both',
      },
    );
  });

  root.dataset.routeEntryState = 'running';

  Promise.allSettled(animations.map((animation) => animation.finished)).then(() => {
    animations.forEach((animation) => animation.cancel());
    complete();
  });
};

window.addEventListener('pageshow', (event) => {
  if (event.persisted) {
    dismissArrivalSkeleton();
    complete();
  }
});

play();
